import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat.js';
import localizedFormat from 'dayjs/plugin/localizedFormat.js';

dayjs.extend(localizedFormat);
dayjs.extend(customParseFormat);

/**
 * Centralized date parse function
 */
export const parseDate = (date?: dayjs.ConfigType, format?: dayjs.OptionType) =>
  dayjs(date, format);

export default parseDate;
